import { createContext, useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';

import { LangEn } from 'assets/locales/en';
import { Language as LanguageManager } from 'assets/locales/fLang';
import { LangFr } from 'assets/locales/fr';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { validateAndCleanXsrfToken } from 'utils/tokenUtils';
import ApiDatabase from '../server';

const roadContext = createContext({});

function ContextProvider({ children }) {
  // *******   Section Sidebar   *******
  const storedSidebarExpanded = localStorage.getItem('sidebar-expanded');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarExpanded, setSidebarExpanded] = useState(
    storedSidebarExpanded === null ? false : storedSidebarExpanded === 'true'
  );
  // *******   Section Refresh   *******
  const [refreshUser, setRefreshUser] = useState(false);
  const refreshLoadUser = () => {
    setRefreshUser(!refreshUser);
  };
  const [refreshWorker, setRefreshWorker] = useState(false);
  const refreshLoadWorker = () => {
    setRefreshWorker(!refreshWorker);
  };
  // *******   Section Language   *******
  //    instancie le manager
  const language = new LanguageManager();
  //    charge les fichiers de langues (ils seront chargés qu'une fois)
  language.loadLanguage(LangFr);
  language.loadLanguage(LangEn);
  //    spécifie la langue en cours
  language.setLanguage('fr');

  // *******   Section Modal   *******
  const [modalShow, setModalShow] = useState(false);
  const [modalType, setModalType] = useState('');
  const [modalData, setModalData] = useState({});
  const [modalDataReturn, setModalDataReturn] = useState({});

  // *******   Section URL   *******
  const [slideOverShow, setSlideOverShow] = useState(false);
  const [slideOverType, setSlideOverType] = useState('');
  const [missionInitialPage, setMissionInitialPage] = useState(undefined);

  // *******   Section URL   *******
  const route = useLocation();
  const { pathname } = route;
  //1 - interimaire 2- entreprise
  const [typeNav, setTypeNav] = useState(1);
  const [email, setEmail] = useState('');
  const [name, setName] = useState({
    firstname: '',
    lastname: '',
  });
  useEffect(() => {
    if (pathname.includes('entreprise')) setTypeNav(2);
    else setTypeNav(1);
  }, [pathname]);

  const [auth, setAuth] = useState({});
  const updateUser = (pToken = '-1', pRole) => {
    if (pToken !== '-1') {
      localStorage.setItem('xsrfToken', pToken);
      localStorage.setItem('rUser', pRole);
    }
  };

  // *******   Section Time Sheets   *******
  const [timeData, setTimeData] = useState({
    id: '',
    id_time_sheet: '',
    index: '',
    day_hours_ent: '',
    periode_one_start: '',
    periode_one_end: '',
    periode_two_start: '',
    periode_two_end: '',
    periode_three_start: '',
    periode_three_end: '',
  });
  const [totalH, setTotalH] = useState(0);
  const [refreshTime, setRefreshTime] = useState(false);
  const [timeCheck, setTimeCheck] = useState({});
  const [content, setContent] = useState('');
  // *******   Section OBJ   *******
  const [expID, setExpID] = useState('');
  const [objID, setObjID] = useState('');
  const [objType, setObjType] = useState('');
  const [adminTempWorkerId, setAdminTempWorkerId] = useState('');
  const [adminUserId, setAdminUserId] = useState('');
  const [adminFileName, setAdminFileName] = useState('');
  const [adminType, setAdminType] = useState('');
  const [updateTempWorker, setUpdateTempWorker] = useState(false);

  const [coeffs, setCoeffs] = useState([]);

  // #region **** Vivier ****
  const [infoVivier, setInfoVivier] = useState();
  const [listVivier, setListVivier] = useState();
  const [refreshVivierLog, setRefreshVivierLog] = useState(true);
  // #endregion **** Vivier ****

  const [userUnAssigned, setUserUnAssigned] = useState({});

  const [currentPageTimeSheetToBeChecked, setCurrentPageTimeSheetToBeChecked] =
    useState(1);
  const [
    timeSheetSearchTimeSheetToBeChecked,
    setTimeSheetSearchTimeSheetToBeChecked,
  ] = useState('');
  const [
    timeSheetSearchTypeTimeSheetToBeChecked,
    setTimeSheetSearchTypeTimeSheetToBeChecked,
  ] = useState('');
  const [dateRangeTimeSheetToBeChecked, setDateRangeTimeSheetToBeChecked] =
    useState([null, null]);

  const [currentPageTimeSheetChecked, setCurrentPageTimeSheetChecked] =
    useState(1);
  const [timeSheetSearchTimeSheetChecked, setTimeSheetSearchTimeSheetChecked] =
    useState('');
  const [
    timeSheetSearchTypeTimeSheetChecked,
    setTimeSheetSearchTypeTimeSheetChecked,
  ] = useState('');
  const [dateRangeTimeSheetChecked, setDateRangeTimeSheetChecked] = useState([
    null,
    null,
  ]);

  const [currentPageTimeSheetLitigation, setCurrentPageTimeSheetLitigation] =
    useState(1);
  const [
    timeSheetSearchTimeSheetLitigation,
    setTimeSheetSearchTimeSheetLitigation,
  ] = useState('');
  const [
    timeSheetSearchTypeTimeSheetLitigation,
    setTimeSheetSearchTypeTimeSheetLitigation,
  ] = useState('');
  const [dateRangeTimeSheetLitigation, setDateRangeTimeSheetLitigation] =
    useState([null, null]);

  const [openModal, setOpenModal] = useState(false);

  const [missionDetails, setMissionDetails] = useState({});
  const [scheduleWeeks, setScheduleWeeks] = useState([]);
  const [updSchedule, setUpdSchedule] = useState(false);
  const [activeScheduleWeekDay, setActiveScheduleWeekDay] = useState([]);
  const [scheduleWeeksNew, setScheduleWeeksNew] = useState([]);
  const [refreshMissionDetails, setRefreshMissionDetails] = useState({});

  const [refreshCompanyBigAccount, setRefreshCompanyBigAccount] =
    useState(false);

  const [reviewUntreatedDelete, setReviewUntreatedDelete] = useState(false);
  const [refreshUntreated, setRefreshUntreated] = useState(false);

  const [refreshQualifications, setRefreshQualifications] = useState(false);
  const [refreshQualification, setRefreshQualification] = useState(false);

  const [usersVivier, setUsersVivier] = useState([]);

  const [userVivierToArchive, setUserVivierToArchive] = useState({});
  const [userVivierToArchiveUpdated, setUserVivierToArchiveUpdated] = useState(
    {}
  );

  const [commentID, setCommentID] = useState('');
  const [commentIDUpd, setCommentIDUpd] = useState('');

  // *******   Section Mission Refuse Candidat   *******
  const [tempWorkerToRefuse, setTempWorkerToRefuse] = useState(null);
  const [refuseMissionId, setRefuseMissionId] = useState(null);
  const [currentRefusedReason, setCurrentRefusedReason] = useState(null);
  const [currentRefusedReasonComment, setCurrentRefusedReasonComment] = useState('');

  const [userData, setUserData] = useState({});
  const [tempWorkerData, setTempWorkerData] = useState({});

  const [target, setTarget] = useState('');

  const [assignationMissionTempWorker, setAssignationMissionTempWorker] =
    useState({});

  const [modifyMissionDetailData, setModifyMissionDetailData] = useState({});

  const [listChangesMissionDetail, setListChangesMissionDetail] = useState({});
  const [
    isChangesNeedsNewContractMissionDetail,
    setIsChangesNeedsNewContractMissionDetail,
  ] = useState({});

  const [searchMissionResult, setSearchMissionResult] = useState([]);

  const [searchTempWorkerResult, setSearchTempWorkerResult] = useState(false);

  const [refreshPayslips, setRefreshPayslips] = useState(false);

  const [
    searchTempWorkerAssignationResult,
    setSearchTempWorkerAssignationResult,
  ] = useState(false);
  const [
    searchTempWorkerAssignationRefusedResult,
    setSearchTempWorkerAssignationRefusedResult,
  ] = useState(false);
  const [
    searchTempWorkerAssignationPendingContactResult,
    setSearchTempWorkerAssignationPendingContactResult,
  ] = useState(false);

  const [searchTempWorkerInviteResult, setSearchTempWorkerInviteResult] =
    useState([]);

  const [infoMission, setInfoMission] = useState(false);

  const [updatedTimesheet, setUpdatedTimesheet] = useState({});

  const [dataCreateMission, setDataCreateMission] = useState({
    company: null,
    idLocation: null,
    activity: '',
    qualification: '',
    title: '',
    tools: [],
    licences: [],
    languages: [],
    contact_name: '',
    contact_poste: 'Responsable',
    location: '',
    dateStart: '',
    dateEnd: '',
    schedule: [],
    isScheduleCheck: true,
    isConfirmedSchedule: false,
    isScheduleRequired: false,
    users_invite: [],
    motif: '',
    other: '',
    other_interim: '',
    salary: '',
    inviteType: '',
    vivierStatus: [],
    vivierSelections: [],
    globalNotificationRequested: false,
    user_assigned: {},
  });

  const infoMissionRef = useRef(infoMission);
  const searchTempWorkerResultRef = useRef(searchTempWorkerResult);

  useEffect(() => {
    infoMissionRef.current = infoMission;
  }, [infoMission]);

  useEffect(() => {
    searchTempWorkerResultRef.current = searchTempWorkerResult;
  }, [searchTempWorkerResult]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const token = validateAndCleanXsrfToken();
      if (!token) {
        window.location.href = process.env.REACT_APP_ADMIN_LOGIN;
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const socketRef = useRef(null);
  const token = localStorage.getItem('xsrfToken');

  useEffect(() => {
    const manageSocket = async () => {
      socketRef.current = await ApiDatabase.connectSocketWithToken();
      if (socketRef.current) {
        const handleSearchMissionUpdated = (change, eventName) => {
          const url = 'admin/searchMission';
          const data = {};
          ApiDatabase.updateCacheEntry(url, data, change.searchMission);

          if (change.searchMission?.length > 0) {
            setSearchMissionResult((prevData) =>
              prevData.map((mission) => {
                const updatedMission = change.searchMission.find(
                  (searchMission) => searchMission._id === mission._id
                );
                return updatedMission ? updatedMission : mission;
              })
            );
          }
        };

        const handleSearchMissionInserted = (change, eventName) => {
          const url = 'admin/searchMission';
          const data = {};
          ApiDatabase.updateCacheEntry(url, data, change.searchMission);

          if (change.searchMission?.length > 0) {
            setSearchMissionResult((prevData) => {
              const updatedData = [...prevData];

              change.searchMission.forEach((newMission) => {
                const existingMission = updatedData.find(
                  (mission) => mission._id === newMission._id
                );

                if (existingMission) {
                  Object.assign(existingMission, newMission);
                } else {
                  updatedData.push(newMission);
                }
              });

              return updatedData;
            });
          }
        };

        const handleTempWorkerPostulateMissionUpdated = (change, eventName) => {
          if (
            change.idMission &&
            change.tempWorkerPostulateMission &&
            infoMissionRef.current?._id === change.idMission
          ) {
            const url = 'admin/getTempWorkerPostulateMission';
            const data = { token, idMission: change.idMission };
            ApiDatabase.updateCacheEntry(
              url,
              data,
              change.tempWorkerPostulateMission
            );

            let refusedUsers = {
              complete: [],
              partial: [],
              not_updated: [],
              incomplete: [],
            };

            let pendingContactUsers = {
              complete: [],
              partial: [],
              not_updated: [],
              incomplete: [],
            };

            let otherUsers = {
              complete: [],
              partial: [],
              not_updated: [],
              incomplete: [],
            };

            const categories = [
              'complete',
              'partial',
              'not_updated',
              'incomplete',
            ];

            categories.forEach((category) => {
              if (change.tempWorkerPostulateMission[category]) {
                refusedUsers[category] = change.tempWorkerPostulateMission[
                  category
                ].filter((user) => user.refused === true);
                pendingContactUsers[category] = change.tempWorkerPostulateMission[
                  category
                ].filter((user) => user.refused === false && user.pendingContact === true);
                otherUsers[category] = change.tempWorkerPostulateMission[
                  category
                ].filter((user) => user.refused === false && user.pendingContact !== true);
              } else {
                refusedUsers[category] = [];
                pendingContactUsers[category] = [];
                otherUsers[category] = [];
              }
            });

            setSearchTempWorkerAssignationRefusedResult(refusedUsers);
            setSearchTempWorkerAssignationPendingContactResult(pendingContactUsers);
            setSearchTempWorkerAssignationResult(otherUsers);
          }
        };

        const handleTempWorkerInviteMissionUpdated = (change, eventName) => {
          if (
            change.idMission &&
            change.tempWorkerInviteMission &&
            infoMissionRef.current?._id === change.idMission
          ) {
            const url = 'admin/getTempWorkerInviteMission';
            const data = { token, idMission: change.idMission };
            ApiDatabase.updateCacheEntry(
              url,
              data,
              change.tempWorkerInviteMission
            );
            setSearchTempWorkerInviteResult(change.tempWorkerInviteMission);
          }
        };

        const handleMissionDetailsByIdUpdated = (change, eventName) => {
          if (
            change.idMission &&
            change.missionDetailsById &&
            infoMissionRef.current?._id === change.idMission
          ) {
            const url = 'admin/getMissionDetailsById';
            const data = { token, idMission: change.idMission };
            ApiDatabase.updateCacheEntry(url, data, change.missionDetailsById);
            setInfoMission(change.missionDetailsById);
          }
        };

        const handleSearchTempWorkerMissionUpdated = (change, eventName) => {
          if (
            change.idMission &&
            change.idUser &&
            change.searchTempWorker &&
            infoMissionRef.current?._id === change.idMission
          ) {
            const combinedArray = Object.values(
              searchTempWorkerResultRef.current
            ).flat();

            const userExists = combinedArray.some(
              (item) => item.id_user === change.idUser
            );

            if (userExists) {
              const url = 'admin/searchTempWorker';
              const data = { token, idMission: change.idMission };
              ApiDatabase.updateCacheEntry(url, data, change.searchTempWorker);

              const categories = [
                'complete',
                'partial',
                'not_updated',
                'incomplete',
              ];

              const searchTempWorkerResultUpdated = {
                ...searchTempWorkerResultRef.current,
              };

              categories.forEach((category) => {
                searchTempWorkerResultUpdated[category] =
                  searchTempWorkerResultUpdated[category].filter(
                    (user) => user.id_user !== change.idUser
                  );
              });

              categories.forEach((category) => {
                const incomingUsers = change.searchTempWorker[category] || [];
                const userData = incomingUsers.find(
                  (u) => u.id_user === change.idUser
                );
                if (userData) {
                  searchTempWorkerResultUpdated[category] = [
                    ...searchTempWorkerResultUpdated[category],
                    { ...userData },
                  ];
                }
              });

              setSearchTempWorkerResult(searchTempWorkerResultUpdated);
            }
          }
        };

        socketRef.current.on('searchMissionUpdated', (change) =>
          handleSearchMissionUpdated(change, 'updated')
        );
        socketRef.current.on('searchMissionInserted', (change) =>
          handleSearchMissionInserted(change, 'updated')
        );
        socketRef.current.on('tempWorkerPostulateMissionUpdated', (change) =>
          handleTempWorkerPostulateMissionUpdated(change, 'updated')
        );
        socketRef.current.on('tempWorkerInviteMissionUpdated', (change) =>
          handleTempWorkerInviteMissionUpdated(change, 'updated')
        );
        socketRef.current.on('missionDetailsByIdUpdated', (change) =>
          handleMissionDetailsByIdUpdated(change, 'updated')
        );
        socketRef.current.on('searchTempWorkerMissionUpdated', (change) =>
          handleSearchTempWorkerMissionUpdated(change, 'updated')
        );
        socketRef.current.on('payslipImportCompleted', (data) => {
          const s = data?.summary;
          toast.success(
            `Import terminé : ${s?.success || 0}/${s?.total || 0} fiche(s) importée(s).`
          );
          setRefreshPayslips((prev) => !prev);
        });
      }
    };

    manageSocket();
  }, []);

  const removeAllParameters = () => {
    const params = new URLSearchParams(window.location.search);
    const preserved = new URLSearchParams();
    ['y', 'm'].forEach((key) => {
      if (params.has(key)) preserved.set(key, params.get(key));
    });
    const qs = preserved.toString();
    const url = window.location.origin + window.location.pathname + (qs ? '?' + qs : '');
    window.history.replaceState({}, document.title, url);
  };

  // Fonction helper pour les optimistic updates de refus/annulation de refus
  // Utilisée par le modal et les composants pour mettre à jour l'état immédiatement
  const updateTempWorkerRefusedState = useCallback((idTempWorker, isRefusing, refusedData = {}) => {
    if (isRefusing) {
      let tempWorkerData = null;
      let keyFound = null;

      setSearchTempWorkerAssignationResult((prevData) => {
        if (!prevData) return prevData;
        const newData = { ...prevData };
        for (const key of ['complete', 'partial', 'not_updated', 'incomplete']) {
          if (newData[key]) {
            const index = newData[key].findIndex((data) => data.id_user === idTempWorker);
            if (index !== -1) {
              tempWorkerData = newData[key][index];
              keyFound = key;
              newData[key] = [...newData[key]];
              newData[key].splice(index, 1);
              break;
            }
          }
        }
        return newData;
      });

      setSearchTempWorkerAssignationPendingContactResult((prevData) => {
        if (!prevData) return prevData;
        const newData = { ...prevData };
        for (const key of ['complete', 'partial', 'not_updated', 'incomplete']) {
          if (newData[key]) {
            const index = newData[key].findIndex((data) => data.id_user === idTempWorker);
            if (index !== -1) {
              if (!tempWorkerData) {
                tempWorkerData = newData[key][index];
                keyFound = key;
              }
              newData[key] = [...newData[key]];
              newData[key].splice(index, 1);
              break;
            }
          }
        }
        return newData;
      });

      setTimeout(() => {
        setSearchTempWorkerAssignationRefusedResult((prevData) => {
          if (!prevData || !tempWorkerData || !keyFound) return prevData;
          const newData = { ...prevData };
          const refusedArray = newData[keyFound] || [];
          const newRefusedArray = [
            ...refusedArray,
            {
              ...tempWorkerData,
              refused: true,
              pendingContact: false,
              refusedReason: refusedData.refusedReason || null,
              refusedReasonId: refusedData.refusedReasonId || null,
              refusedReasonComment: refusedData.refusedReasonComment || null,
            },
          ];
          newRefusedArray.sort((a, b) => {
            const lastnameA = a.lastname?.toLowerCase() || '';
            const lastnameB = b.lastname?.toLowerCase() || '';
            return lastnameA.localeCompare(lastnameB);
          });
          return { ...newData, [keyFound]: newRefusedArray };
        });
      }, 0);
    } else {
      let tempWorkerData = null;
      let keyFound = null;

      setSearchTempWorkerAssignationRefusedResult((prevData) => {
        if (!prevData) return prevData;
        const newData = { ...prevData };
        for (const key of ['complete', 'partial', 'not_updated', 'incomplete']) {
          if (newData[key]) {
            const index = newData[key].findIndex((data) => data.id_user === idTempWorker);
            if (index !== -1) {
              tempWorkerData = newData[key][index];
              keyFound = key;
              newData[key] = [...newData[key]];
              newData[key].splice(index, 1);
              break;
            }
          }
        }
        return newData;
      });

      setTimeout(() => {
        setSearchTempWorkerAssignationResult((prevData) => {
          if (!prevData || !tempWorkerData || !keyFound) return prevData;
          const newData = { ...prevData };
          const assignationArray = newData[keyFound] || [];
          const newAssignationArray = [
            ...assignationArray,
            {
              ...tempWorkerData,
              refused: false,
              pendingContact: false,
              refusedReason: null,
              refusedReasonId: null,
              refusedReasonComment: null,
            },
          ];
          newAssignationArray.sort((a, b) => {
            const lastnameA = a.lastname?.toLowerCase() || '';
            const lastnameB = b.lastname?.toLowerCase() || '';
            return lastnameA.localeCompare(lastnameB);
          });
          return { ...newData, [keyFound]: newAssignationArray };
        });
      }, 0);
    }
  }, []);

  const updateTempWorkerPendingContactState = useCallback((idTempWorker, isPending) => {
    if (isPending) {
      let tempWorkerData = null;
      let keyFound = null;

      setSearchTempWorkerAssignationResult((prevData) => {
        if (!prevData) return prevData;
        const newData = { ...prevData };
        for (const key of ['complete', 'partial', 'not_updated', 'incomplete']) {
          if (newData[key]) {
            const index = newData[key].findIndex((data) => data.id_user === idTempWorker);
            if (index !== -1) {
              tempWorkerData = newData[key][index];
              keyFound = key;
              newData[key] = [...newData[key]];
              newData[key].splice(index, 1);
              break;
            }
          }
        }
        return newData;
      });

      setTimeout(() => {
        setSearchTempWorkerAssignationPendingContactResult((prevData) => {
          if (!prevData || !tempWorkerData || !keyFound) return prevData;
          const newData = { ...prevData };
          const pendingArray = newData[keyFound] || [];
          const newPendingArray = [
            ...pendingArray,
            { ...tempWorkerData, pendingContact: true },
          ];
          newPendingArray.sort((a, b) => {
            const lastnameA = a.lastname?.toLowerCase() || '';
            const lastnameB = b.lastname?.toLowerCase() || '';
            return lastnameA.localeCompare(lastnameB);
          });
          return { ...newData, [keyFound]: newPendingArray };
        });
      }, 0);
    } else {
      let tempWorkerData = null;
      let keyFound = null;

      setSearchTempWorkerAssignationPendingContactResult((prevData) => {
        if (!prevData) return prevData;
        const newData = { ...prevData };
        for (const key of ['complete', 'partial', 'not_updated', 'incomplete']) {
          if (newData[key]) {
            const index = newData[key].findIndex((data) => data.id_user === idTempWorker);
            if (index !== -1) {
              tempWorkerData = newData[key][index];
              keyFound = key;
              newData[key] = [...newData[key]];
              newData[key].splice(index, 1);
              break;
            }
          }
        }
        return newData;
      });

      setTimeout(() => {
        setSearchTempWorkerAssignationResult((prevData) => {
          if (!prevData || !tempWorkerData || !keyFound) return prevData;
          const newData = { ...prevData };
          const assignationArray = newData[keyFound] || [];
          const newAssignationArray = [
            ...assignationArray,
            { ...tempWorkerData, pendingContact: false },
          ];
          newAssignationArray.sort((a, b) => {
            const lastnameA = a.lastname?.toLowerCase() || '';
            const lastnameB = b.lastname?.toLowerCase() || '';
            return lastnameA.localeCompare(lastnameB);
          });
          return { ...newData, [keyFound]: newAssignationArray };
        });
      }, 0);
    }
  }, []);

  // Fonction helper pour les optimistic updates d'attribution de mission
  // Met à jour searchMissionResult et infoMission immédiatement
  const updateMissionAssignment = useCallback((idMission, userData, isAssigning = true) => {
    // Convertir en string pour les comparaisons
    const missionIdStr = idMission?.toString?.() || idMission;
    
    if (isAssigning) {
      // Mettre à jour searchMissionResult
      setSearchMissionResult((prevData) => {
        if (!Array.isArray(prevData)) return prevData;
        return prevData.map((mission) => {
          const missionRealIdStr = mission.id_mission_real?.toString?.() || mission.id_mission_real;
          const missionIdStrCompare = mission._id?.toString?.() || mission._id;
          if (missionRealIdStr === missionIdStr || missionIdStrCompare === missionIdStr) {
            return {
              ...mission,
              user: {
                user_id: userData._id,
                firstname: userData.firstname,
                lastname: userData.lastname,
                id_bestt: userData.id_bestt,
                email: userData.email,
                phone: userData.phone,
              },
            };
          }
          return mission;
        });
      });

      // Mettre à jour infoMission si c'est la mission actuelle
      setInfoMission((prevInfo) => {
        if (!prevInfo) return prevInfo;
        const prevIdStr = prevInfo._id?.toString?.() || prevInfo._id;
        if (prevIdStr !== missionIdStr) return prevInfo;
        return {
          ...prevInfo,
          user_assigned: userData._id,
          user_assigned_infos: {
            tempworker: {
              _id: userData._id,
              firstname: userData.firstname,
              lastname: userData.lastname,
              email: userData.email,
              phone: userData.phone,
              id_bestt: userData.id_bestt,
            },
          },
        };
      });
    } else {
      // Rollback : retirer l'attribution
      setSearchMissionResult((prevData) => {
        if (!Array.isArray(prevData)) return prevData;
        return prevData.map((mission) => {
          const missionRealIdStr = mission.id_mission_real?.toString?.() || mission.id_mission_real;
          const missionIdStrCompare = mission._id?.toString?.() || mission._id;
          if (missionRealIdStr === missionIdStr || missionIdStrCompare === missionIdStr) {
            return {
              ...mission,
              user: null,
            };
          }
          return mission;
        });
      });

      setInfoMission((prevInfo) => {
        if (!prevInfo) return prevInfo;
        const prevIdStr = prevInfo._id?.toString?.() || prevInfo._id;
        if (prevIdStr !== missionIdStr) return prevInfo;
        return {
          ...prevInfo,
          user_assigned: null,
          user_assigned_infos: null,
        };
      });
    }
  }, []);

  return (
    <roadContext.Provider
      value={{
        language,
        modalShow,
        setModalShow,
        modalType,
        setModalType,
        modalData,
        setModalData,
        modalDataReturn,
        setModalDataReturn,
        slideOverShow,
        setSlideOverShow,
        slideOverType,
        setSlideOverType,
        typeNav,
        email,
        setEmail,
        name,
        setName,
        updateUser,
        auth,
        setAuth,
        refreshUser,
        setRefreshUser,
        refreshLoadUser,
        refreshWorker,
        setRefreshWorker,
        refreshLoadWorker,
        sidebarOpen,
        setSidebarOpen,
        sidebarExpanded,
        setSidebarExpanded,
        expID,
        setExpID,
        objID,
        setObjID,
        objType,
        setObjType,
        userUnAssigned,
        setUserUnAssigned,
        adminTempWorkerId,
        setAdminTempWorkerId,
        adminUserId,
        setAdminUserId,
        adminFileName,
        setAdminFileName,
        adminType,
        setAdminType,
        updateTempWorker,
        setUpdateTempWorker,
        timeData,
        setTimeData,
        refreshTime,
        setRefreshTime,
        timeCheck,
        setTimeCheck,
        content,
        setContent,
        totalH,
        setTotalH,
        coeffs,
        setCoeffs,
        infoVivier,
        setInfoVivier,
        listVivier,
        setListVivier,
        refreshVivierLog,
        setRefreshVivierLog,

        currentPageTimeSheetToBeChecked,
        setCurrentPageTimeSheetToBeChecked,
        timeSheetSearchTimeSheetToBeChecked,
        setTimeSheetSearchTimeSheetToBeChecked,
        timeSheetSearchTypeTimeSheetToBeChecked,
        setTimeSheetSearchTypeTimeSheetToBeChecked,
        dateRangeTimeSheetToBeChecked,
        setDateRangeTimeSheetToBeChecked,

        currentPageTimeSheetChecked,
        setCurrentPageTimeSheetChecked,
        timeSheetSearchTimeSheetChecked,
        setTimeSheetSearchTimeSheetChecked,
        timeSheetSearchTypeTimeSheetChecked,
        setTimeSheetSearchTypeTimeSheetChecked,
        dateRangeTimeSheetChecked,
        setDateRangeTimeSheetChecked,

        currentPageTimeSheetLitigation,
        setCurrentPageTimeSheetLitigation,
        timeSheetSearchTimeSheetLitigation,
        setTimeSheetSearchTimeSheetLitigation,
        timeSheetSearchTypeTimeSheetLitigation,
        setTimeSheetSearchTypeTimeSheetLitigation,
        dateRangeTimeSheetLitigation,
        setDateRangeTimeSheetLitigation,

        openModal,
        setOpenModal,

        missionDetails,
        setMissionDetails,
        scheduleWeeks,
        setScheduleWeeks,
        updSchedule,
        setUpdSchedule,
        activeScheduleWeekDay,
        setActiveScheduleWeekDay,
        scheduleWeeksNew,
        setScheduleWeeksNew,
        refreshMissionDetails,
        setRefreshMissionDetails,

        refreshCompanyBigAccount,
        setRefreshCompanyBigAccount,
        removeAllParameters,

        reviewUntreatedDelete,
        setReviewUntreatedDelete,
        refreshUntreated,
        setRefreshUntreated,

        refreshQualifications,
        setRefreshQualifications,
        refreshQualification,
        setRefreshQualification,

        usersVivier,
        setUsersVivier,

        userVivierToArchive,
        setUserVivierToArchive,
        userVivierToArchiveUpdated,
        setUserVivierToArchiveUpdated,

        commentID,
        setCommentID,
        commentIDUpd,
        setCommentIDUpd,

        tempWorkerToRefuse,
        setTempWorkerToRefuse,
        refuseMissionId,
        setRefuseMissionId,
        currentRefusedReason,
        setCurrentRefusedReason,
        currentRefusedReasonComment,
        setCurrentRefusedReasonComment,

        userData,
        setUserData,
        tempWorkerData,
        setTempWorkerData,

        target,
        setTarget,

        assignationMissionTempWorker,
        setAssignationMissionTempWorker,

        modifyMissionDetailData,
        setModifyMissionDetailData,

        listChangesMissionDetail,
        setListChangesMissionDetail,
        isChangesNeedsNewContractMissionDetail,
        setIsChangesNeedsNewContractMissionDetail,

        searchMissionResult,
        setSearchMissionResult,

        searchTempWorkerAssignationResult,
        setSearchTempWorkerAssignationResult,
        searchTempWorkerAssignationRefusedResult,
        setSearchTempWorkerAssignationRefusedResult,
        searchTempWorkerAssignationPendingContactResult,
        setSearchTempWorkerAssignationPendingContactResult,
        updateTempWorkerRefusedState,
        updateTempWorkerPendingContactState,
        updateMissionAssignment,

        searchTempWorkerInviteResult,
        setSearchTempWorkerInviteResult,

        infoMission,
        setInfoMission,

        searchTempWorkerResult,
        setSearchTempWorkerResult,

        updatedTimesheet,
        setUpdatedTimesheet,

        dataCreateMission,
        setDataCreateMission,

        refreshPayslips,
        setRefreshPayslips,

        missionInitialPage,
        setMissionInitialPage,
      }}
    >
      {children}
    </roadContext.Provider>
  );
}

export { ContextProvider, roadContext };
